import type { UserPreferences, PitchTolerancePreset } from '../types';

const STORAGE_KEY = 'violinlab.preferences';
const PRESET_CENTS: Record<PitchTolerancePreset, number> = {
  pro: 5,
  advanced: 10,
  beginner: 15,
};

export const DEFAULT_PREFERENCES: UserPreferences = {
  A4: 440,
  midiOffset: -50,
  autoStringDetection: true,
  timbreThreshold: 70,
  pitchTolerance: 15,
  pitchTolerancePreset: 'beginner',
  language: 'zh',
};

export function loadPreferences(): UserPreferences {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_PREFERENCES };
    return { ...DEFAULT_PREFERENCES, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_PREFERENCES };
  }
}

export function savePreferences(prefs: UserPreferences): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch {
    // storage may be unavailable (private mode); preferences stay in-memory only
  }
}

export function presetToCents(preset: PitchTolerancePreset): number {
  return PRESET_CENTS[preset];
}
